export default "__VITE_ASSET__DusGmKsA__"